module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills-large@3x.55c5d5a3.png";